import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "float-end" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "System status", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Info", -1)
const _hoisted_5 = { class: "spinner-wrapper mb-3" }
const _hoisted_6 = {
  key: 0,
  class: "status-table"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Status:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "App:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Environment:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Version:", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Git version:", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Git hash:", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h1", null, "System configuration", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h2", null, "AppRoles", -1)
const _hoisted_16 = { class: "row mb-3 spinner-wrapper" }
const _hoisted_17 = {
  key: 0,
  class: "accordion app-roles",
  id: "appRolesAccordion"
}
const _hoisted_18 = { class: "accordion-header" }
const _hoisted_19 = ["data-bs-target", "aria-controls"]
const _hoisted_20 = ["id"]
const _hoisted_21 = { class: "accordion-body" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h2", null, "Permissions in system", -1)
const _hoisted_23 = { class: "row mb-3 spinner-wrapper" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "permissions-table" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h2", null, "Connection Strings", -1)
const _hoisted_27 = { class: "row mb-3 spinner-wrapper" }
const _hoisted_28 = {
  key: 0,
  class: "status-table"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Core DB:", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "CallDetailRecord DB:", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "OrdReg DB:", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "PoolIntranet DB:", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Visma General DB:", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("h2", null, "Weblink", -1)
const _hoisted_35 = { class: "row mb-3 spinner-wrapper" }
const _hoisted_36 = {
  key: 0,
  class: "status-table"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Server URL:", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Username:", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h2", null, "Azure AD", -1)
const _hoisted_40 = { class: "row mb-3 spinner-wrapper" }
const _hoisted_41 = {
  key: 0,
  class: "status-table"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "AAD Instance:", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "AAD TenantId:", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "AAD ClientId:", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "AAD Audience:", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "AAD AppObjectId:", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "AAD CacheTimeout:", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "AAD Authority:", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("h2", null, "Core Services", -1)
const _hoisted_50 = { class: "row mb-3 spinner-wrapper" }
const _hoisted_51 = {
  key: 0,
  class: "status-table"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Logo Storage Backend:", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Email Sender Backend:", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Active Directory Backend:", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Email Recipients:", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Core.Visma Endpoint URL:", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Core.Visma Application ID:", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("h2", null, "Active Directory", -1)
const _hoisted_59 = { class: "row mb-3 spinner-wrapper" }
const _hoisted_60 = {
  key: 0,
  class: "status-table"
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Server:", -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Username:", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("h2", null, "SMTP", -1)
const _hoisted_64 = { class: "row mb-3 spinner-wrapper" }
const _hoisted_65 = {
  key: 0,
  class: "status-table"
}
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Sender:", -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Host:", -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Port:", -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "EnableSSL:", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Username:", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("h2", null, "Service Bus", -1)
const _hoisted_72 = { class: "row mb-3 spinner-wrapper" }
const _hoisted_73 = {
  key: 0,
  class: "status-table"
}
const _hoisted_74 = { class: "heading" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("h1", null, "System Connectivity", -1)
const _hoisted_78 = { class: "row mb-2" }
const _hoisted_79 = { class: "col" }
const _hoisted_80 = ["disabled"]
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { key: 1 }
const _hoisted_83 = { class: "row" }
const _hoisted_84 = { class: "table table-striped" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Service"),
    /*#__PURE__*/_createElementVNode("th", null, "Connected"),
    /*#__PURE__*/_createElementVNode("th", null, "Response")
  ])
], -1)
const _hoisted_86 = { key: 0 }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "3",
  class: "text-center"
}, "Run tests first", -1)
const _hoisted_88 = [
  _hoisted_87
]
const _hoisted_89 = { key: 1 }
const _hoisted_90 = {
  colspan: "3",
  class: "text-center"
}
const _hoisted_91 = { class: "marker-wrapper text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_messages = _resolveComponent("messages")!
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_spinner = _resolveComponent("spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_messages, { ref: "errorHandler" }, null, 512)
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", {
          class: "btn btn-lg btn-outline-secondary mt-1",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args)))
        }, [
          _createVNode(_component_fa_icon, { icon: "sync-alt" })
        ])
      ]),
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_spinner, { loading: _ctx.loadingSystemStatus }, null, 8, ["loading"]),
        (_ctx.systemStatus)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemStatus.status), 1),
              _hoisted_8,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemStatus.app), 1),
              _hoisted_9,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemStatus.env), 1),
              _hoisted_10,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemStatus.version), 1),
              _hoisted_11,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemStatus.gitVersion), 1),
              _hoisted_12,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemStatus.gitHash), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_13,
    _createElementVNode("section", null, [
      _hoisted_14,
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_spinner, { loading: _ctx.loadingSystemConfig }, null, 8, ["loading"]),
        (_ctx.systemConfig?.appRoles)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemConfig.appRoles, (role) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: role.guid,
                  class: "accordion-item"
                }, [
                  _createElementVNode("h2", _hoisted_18, [
                    _createElementVNode("button", {
                      class: "accordion-button collapsed app-role-header",
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": `#r${role.guid}__permissions`,
                      "aria-expanded": "false",
                      "aria-controls": `#r${role.guid}__permissions`
                    }, _toDisplayString(role.name), 9, _hoisted_19)
                  ]),
                  _createElementVNode("div", {
                    id: `r${role.guid}__permissions`,
                    class: "accordion-collapse collapse",
                    "data-bs-parent": "appRolesAccordion"
                  }, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(role.permissions, (perm) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: perm,
                            class: "permission"
                          }, _toDisplayString(perm), 1))
                        }), 128))
                      ])
                    ])
                  ], 8, _hoisted_20)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_22,
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_spinner, { loading: _ctx.loadingSystemConfig }, null, 8, ["loading"]),
        (_ctx.systemConfig)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemConfig.permissions, (perm) => {
                  return (_openBlock(), _createElementBlock("div", { key: perm }, _toDisplayString(perm), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_26,
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_spinner, { loading: _ctx.loadingSystemConfig }, null, 8, ["loading"]),
        (_ctx.systemConfig)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.connectionStrings.coreDb), 1),
              _hoisted_30,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.connectionStrings.callDetailRecordDb), 1),
              _hoisted_31,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.connectionStrings.ordRegDb), 1),
              _hoisted_32,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.connectionStrings.poolIntranetDb), 1),
              _hoisted_33,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.connectionStrings.vismaGeneralDb), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_34,
      _createElementVNode("div", _hoisted_35, [
        _createVNode(_component_spinner, { loading: _ctx.loadingSystemConfig }, null, 8, ["loading"]),
        (_ctx.systemConfig)
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.weblink.serverURL), 1),
              _hoisted_38,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.weblink.username), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_39,
      _createElementVNode("div", _hoisted_40, [
        _createVNode(_component_spinner, { loading: _ctx.loadingSystemConfig }, null, 8, ["loading"]),
        (_ctx.systemConfig)
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
              _hoisted_42,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.azureAd.instance), 1),
              _hoisted_43,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.azureAd.tenantId), 1),
              _hoisted_44,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.azureAd.clientId), 1),
              _hoisted_45,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.azureAd.audience), 1),
              _hoisted_46,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.azureAd.appObjectId), 1),
              _hoisted_47,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.azureAd.cacheTimeout) + " (sec)", 1),
              _hoisted_48,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.azureAd.authority), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_49,
      _createElementVNode("div", _hoisted_50, [
        _createVNode(_component_spinner, { loading: _ctx.loadingSystemConfig }, null, 8, ["loading"]),
        (_ctx.systemConfig)
          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
              _hoisted_52,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.coreServices.logoStorageBackend), 1),
              _hoisted_53,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.coreServices.emailSenderBackend), 1),
              _hoisted_54,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.coreServices.activeDirectoryBackend), 1),
              _hoisted_55,
              _createElementVNode("div", null, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemConfig.coreServices.emailRecipients, (k, v) => {
                    return (_openBlock(), _createElementBlock("li", { key: v }, _toDisplayString(v) + " → " + _toDisplayString(k), 1))
                  }), 128))
                ])
              ]),
              _hoisted_56,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.coreServices.visma.endpointUrl), 1),
              _hoisted_57,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.coreServices.visma.applicationId), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_58,
      _createElementVNode("div", _hoisted_59, [
        _createVNode(_component_spinner, { loading: _ctx.loadingSystemConfig }, null, 8, ["loading"]),
        (_ctx.systemConfig)
          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
              _hoisted_61,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.activeDirectory.server), 1),
              _hoisted_62,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.activeDirectory.username), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_63,
      _createElementVNode("div", _hoisted_64, [
        _createVNode(_component_spinner, { loading: _ctx.loadingSystemConfig }, null, 8, ["loading"]),
        (_ctx.systemConfig)
          ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
              _hoisted_66,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.smtp.sender), 1),
              _hoisted_67,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.smtp.host), 1),
              _hoisted_68,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.smtp.port), 1),
              _hoisted_69,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.smtp.enableSSL), 1),
              _hoisted_70,
              _createElementVNode("div", null, _toDisplayString(_ctx.systemConfig.smtp.username), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_71,
      _createElementVNode("div", _hoisted_72, [
        _createVNode(_component_spinner, { loading: _ctx.loadingSystemConfig }, null, 8, ["loading"]),
        (_ctx.systemConfig)
          ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_ctx.systemConfig.serviceBus), ([name, cfg]) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: name }, [
                  _createElementVNode("div", _hoisted_74, _toDisplayString(name) + ":", 1),
                  _hoisted_75,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(cfg), ([prop, val]) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: prop }, [
                      _createElementVNode("div", null, _toDisplayString(prop), 1),
                      _createElementVNode("div", null, _toDisplayString(val), 1)
                    ], 64))
                  }), 128))
                ], 64))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_76,
    _createElementVNode("section", null, [
      _hoisted_77,
      _createElementVNode("div", _hoisted_78, [
        _createElementVNode("div", _hoisted_79, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.runSystemConnectivityTest())),
            disabled: _ctx.runningSystemConnectivityTest
          }, [
            (!_ctx.runningSystemConnectivityTest)
              ? (_openBlock(), _createElementBlock("span", _hoisted_81, "Run test"))
              : (_openBlock(), _createElementBlock("span", _hoisted_82, [
                  _createTextVNode("Testing... "),
                  _createVNode(_component_fa_icon, { icon: "spinner" })
                ]))
          ], 8, _hoisted_80)
        ])
      ]),
      _createElementVNode("div", _hoisted_83, [
        _createVNode(_component_messages, { ref: "systemConnectivityErrorHandler" }, null, 512)
      ]),
      _createElementVNode("table", _hoisted_84, [
        _hoisted_85,
        _createElementVNode("tbody", null, [
          (!_ctx.systemConnectivityTestResults && !_ctx.runningSystemConnectivityTest)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_86, _hoisted_88))
            : _createCommentVNode("", true),
          (!_ctx.systemConnectivityTestResults && _ctx.runningSystemConnectivityTest)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_89, [
                _createElementVNode("td", _hoisted_90, [
                  _createVNode(_component_fa_icon, { icon: "spinner" })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemConnectivityTestResults, ([systemName, status]) => {
            return (_openBlock(), _createElementBlock("tr", { key: systemName }, [
              _createElementVNode("th", null, _toDisplayString(systemName), 1),
              _createElementVNode("td", _hoisted_91, [
                _createElementVNode("span", {
                  class: _normalizeClass(["marker", status.isConnected ? 'green' : 'red'])
                }, null, 2)
              ]),
              _createElementVNode("td", null, _toDisplayString(status.responseMessage), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}